export default __webpack_public_path__ + "static/text-preview@2x-893f9b22fa50d77e9bc5e334edf1c81d.png";